import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import ChartCategoryCreateUpdateForm from "./ChartCategoryCreateUpdateForm";
import localStrings from "../../../localStrings";
import {MODE_CREATE} from "../../../components/CrudFrom/GeneralEditor";
import {Link as RouterLink} from "react-router-dom";
import {
  chartCategoryListRoute,
  chartImplementationListRoute,
  dashboardBaseRoute,
  establishmentListRoute
} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PageWithTitle from "../../../components/pages/pageWithTitle";

const ChartImplementationAddView = () => {


  function getMainButtons() {
    return (


      <RouterLink to={'/' + dashboardBaseRoute + '/' + chartCategoryListRoute}
                  style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          variant="contained"
          startIcon={(
            <SvgIcon>
              <ArrowBackIcon />
            </SvgIcon>
          )}
        >
          {localStrings.backToList}
        </Button>
      </RouterLink>
    )
  }

  return (
    <PageWithTitle title={localStrings.createChartCategory} mainButtons={getMainButtons()}>
      <ChartCategoryCreateUpdateForm modeEdit={MODE_CREATE}/>
    </PageWithTitle>
  );
};

export default ChartImplementationAddView;
